import { t } from 'helpers/i18n';
import { IMap } from '../interfaces';

const IAM_SCOPES = [
  'openid',
  'profile',
  'read:permissions',
  // You can add more scopes (granted services) here
  'catalog',
  'ticket-v2-apis',
];

const DEFAULT_SIZE_CHANGER = {
  showSizeChanger: true,
  pageSizeOptions: ['10', '20', '50', '100'],
  locale: {
    items_per_page: t('RecordPerPage'),
  },
};

export const TWO_COLUMN_LAYOUT = {
  xs: 24,
  md: 12,
};
export const THREE_COLUMN_LAYOUT = {
  xs: 24,
  md: 8,
};

export enum EDirection {
  DESC = 'desc',
  ASC = 'asc',
}

export const MOBILE = 'Mobile';

export const NOTI_DEBOUNCE_TIME = 50;

const PAGE_SIZE_OPTIONS = [10, 15, 20, 50, 100];

const DEFAULT_PARAMS = {
  page: 1,
  pageSize: 10,
};

const RIBBON_CONFIGS: IMap<{ className: string; name: string }> = {
  'test-1': {
    className: 'test-1',
    name: 'TEST-1',
  },
  dev: {
    className: 'dev',
    name: 'DEV',
  },
  stag: {
    className: 'stag',
    name: 'STAG',
  },
};

export default {
  IAM_SCOPES,
  ALL: 'all',
  ALL_VALUE: 0,
  TABLET_WIDTH: 768,
  DEFAULT_SIZE_CHANGER,
  DEBOUNCE_TIME: 1000,
  PAGE_SIZE_OPTIONS,
  CODE_400: 400,
  DEFAULT_PARAMS,
  ALL_VALUE_NUMBER: -1,
  RIBBON_CONFIGS,
  APP_DEALER: 'Dealer',
};
